import { Link } from 'react-router-dom';

function Slider({data}:any) {
    return ( 
        <div className="container-fluid position-relative p-0">
            <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {data.map((row:any,index: number) => 
                        <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={index}>
                            <img className="w-100" src={row.image} alt="slider" style={{maxHeight: "800px" , backgroundSize:"cover"}}/>
                            <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                            <div className="p-3" style={{maxWidth: "900px"}}>
                                <h5 className="text-white mb-3 animated slideInDown">{row.title}</h5>
                                <h1 className="display-1 text-white mb-md-4 animated zoomIn">{row.subtitle}</h1>
                                <Link to="/login" className="btn btn-outline-danger text-light py-md-3 px-md-5 me-3 animated slideInRight border-3">ثبت نام در سایت</Link>
                                <Link to="/blog" className="btn btn-danger py-md-3 px-md-5 animated slideInLeft border-3">مشاهده مصاحبه ها</Link>
                            </div>
                        </div>
                    </div>)}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel"
                    data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#header-carousel"
                    data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
     );
}

export default Slider;